import { apiFetch } from '../../../apiClient';
import { apiMap, settings } from '../../../config/constants';
import { getSessionDatas } from '../../../utils';
import { showLoaing, clearError } from '../../App/state/action';
import { updateStep } from '../../CompanyRegistration/state/action';


export const SubmitPreview = (data) => (dispatch) => {
    dispatch(showLoaing(true));
    apiFetch(apiMap.previewSubmit, {
        method: settings.post,
        hostname: settings.hostnameSubmit,
        paramsObj: {
            "applicationId": getSessionDatas().applicationId,
            ...data
        }
    })(dispatch).then((result) => {
        //200 ---ok
        //RBB010-03 -----reject or referral 
        //others-----preview service call not success
        dispatch(showLoaing(false));
        if (result && result.respCode === "200") {
            dispatch(updateStep({"progressIndex": 4, "status": 1}));
        } else {
            dispatch(updateStep({"status": 3}));
        }
    }).catch(error => {
        dispatch(updateStep({"status": 3}));
        dispatch(showLoaing(false));
        dispatch(clearError());
    })
};


// WEBPACK FOOTER //
// ./src/views/PreviewQuestion/state/action.js